import { Dialog, DialogContent, Button, DialogActions, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { getOutputOrderByPedido } from "../functions";
import SalidaTable from "components-base/salidas/components/SalidaTable";

const OrderOutput = ({ open, handleClose }) => {
  const { defaultDataPedido } = useSelector(({ pedido }) => pedido);
  const [data, setData] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [searchValue, setSearchValue] = useState(null);

  useEffect(() => {
    if (!defaultDataPedido?.id) return;
    const fetchData = async () => {
      let result = await getOutputOrderByPedido(defaultDataPedido.id);
      setData(result || []);
    };
    fetchData();
  }, [defaultDataPedido?.id, refresh]);

  const handleSearch = (e) => setSearchValue(e.target.value);
  const clearSearch = () => setSearchValue(null);

  return (
    <Dialog fullWidth maxWidth="xl" open={open}>
      <DialogContent>
        <SalidaTable
          data={data}
          refresh={refresh}
          setRefresh={setRefresh}
          searchValue={searchValue}
          handleSearch={handleSearch}
          clearSearch={clearSearch}
          pedido={defaultDataPedido}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color={"secondary"} variant="contained">
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default OrderOutput;
